<div class="wrap" id="rs">
  <ng-container *ngIf="!confirm">
    <h4>Souhaitez-vous vous inscrire avec les informations suivantes : </h4>
    <mat-dialog-content class="content">
      <p>Nom: <strong>{{data.firstName}}</strong></p>
      <p>Prénom: <strong>{{data.lastName}}</strong></p>
      <p>Email: <strong>{{data.email}}</strong></p>
    </mat-dialog-content>
    <div class="conditions">
      <input type="checkbox" (click)="isCheck()">
      <p>J'accepte les conditions
        d'utilisation de le FFVoile. <a [routerLink]="['/conditions']" routerLinkActive="router-link-active">Plus d'info
          ici.</a></p>
    </div>
    <mat-dialog-actions align="end">
      <button mat-dialog-close class="back">Annuler</button>
      <button cdkFocusInitial class="confirm" (click)="confirmToRegister()">Confirmer</button>
    </mat-dialog-actions>
  </ng-container>

  <ng-container *ngIf="confirm && data.provider !== 'apple'">
    <div class="wrap_confirm">
      <fa-icon [icon]="faPaperPlane"></fa-icon>
      <h1>Inscription réussie !</h1>
      <p>Votre inscription a bien été enregistrée.</p>
      <p>Un mail de confirmation vous a été envoyé à l'adresse mail <span>{{data.email}}</span> </p>
      <p>Veuillez confirmer votre adresse mail</p>

      <mat-dialog-actions align="end">
        <button cdkFocusInitial class="confirm" (click)="dialogRef.close()">Ok</button>
      </mat-dialog-actions>
    </div>
  </ng-container>
  <ng-container *ngIf="confirm && data.provider === 'apple'">
    <div class="wrap_confirm">
      <fa-icon [icon]="faCheckCircle" [style.font-size.em]="2.2"></fa-icon>
      <h1>Inscription réussie !</h1>
      <p>Votre inscription a bien été enregistrée.</p>


      <mat-dialog-actions align="end">
        <button cdkFocusInitial class="confirm" (click)="dialogRef.close()">Ok</button>
      </mat-dialog-actions>
    </div>
  </ng-container>
</div>